<template>
  <div class="solution-detail" id="solution-detail">
    <div class="solution-header">
      <div class="title" :class="{'en-t': !$theme}">{{ $theme ? solutionDetail.title : solutionDetail.title_eng }}</div>
      <div class="title-en">{{ $theme ? solutionDetail.title_eng : imageObj[solutionDetail.title]&&imageObj[solutionDetail.title].shorthand}}</div>
      <div class="line"></div>
      <div class="desc">{{ $theme ? solutionDetail.resume : solutionDetail.resume_eng }}</div>
      <video
          v-if="imageObj[solutionDetail.title]&&imageObj[solutionDetail.title].video.includes('mp4')"
          :src="imageObj[solutionDetail.title]&&imageObj[solutionDetail.title].video"
          :autoplay="true"
          muted
          loop
      ></video>
      <img v-else :src="imageObj[solutionDetail.title]&&imageObj[solutionDetail.title].video" alt="">
      <img src="../../assets/img/solution/solution-mask.png" alt="">
    </div>
    <div class="one-two-container">
    <div class="one-con">
      <img src="../../assets/img/solution/daosanjiao.png" alt="">
      <div class="new-title new-title2">
        <div class="cn-name">{{ $theme ? "行业背景" : "INDUSTRY BACKGROUND"}}</div>
        <div class="en-name">{{ $theme ? "Industry Background" : '' }}</div>
        <div class="new-line"></div>
      </div>
      <div class="content" v-html="$theme ? solutionDetail.industryBackground : solutionDetail.industryBackground_eng">
        
      </div>
    </div>
    <div class="two-con">
      <div class="new-title new-title2">
        <div class="cn-name">{{ $theme ? "行业痛点" : "INDUSTRY PAIN POINT"}}</div>
        <div class="en-name">{{ $theme ? "Industry Pain Point" : '' }}</div>
        <div class="new-line"></div>
      </div>
      <div class="content">
        <div :class="{ 'three-column': solutionDetail.painPoints.length == 3}" class="one-point" v-for="(item,ind) in solutionDetail.painPoints" :key="ind+'vv'">
          <img class="index" :src="indexImgList[ind]" alt="">
          <img class="main-img" :src="imageObj[solutionDetail.title].points&&imageObj[solutionDetail.title].points[ind]" alt="">
          <div class="l-title">{{ $theme ? item.title.replace('：','').replace(':','') : item.title_eng.replace(':','').replace('：','') || '暂无' }}</div>
          <div class="l-desc" v-html="$theme ? item.content : item.content_eng"></div>
        </div>
      </div>
    </div>
  </div>
    <div class="three-con">
      <div class="inner-con">
        <div class="new-title">
        <div class="cn-name">{{ $theme ? "方案概述" : "SCHEME OVERVIEW"}}</div>
        <div class="en-name">{{ $theme ? "Scheme Overview" : '' }}</div>
          <div class="new-line"></div>
        </div>
        <div class="gaishu">
          {{ $theme ? solutionDetail.overview.overviewDetail : solutionDetail.overview.overviewDetail_eng  }}
        </div>
        <div class="title" 
        :class="{
          'show-animated': showAnimated,
          'en-title-s': !$theme && !(imageObj[solutionDetail.title]&&imageObj[solutionDetail.title].shorthand),
          'en-title-t': !$theme && (imageObj[solutionDetail.title]&&imageObj[solutionDetail.title].shorthand),
          }"
        >
        {{ $theme ? solutionDetail.title : (imageObj[solutionDetail.title]&&imageObj[solutionDetail.title].shorthand || solutionDetail.title_eng) }}
      </div>
        <div 
          :class="{'show-animated': showAnimated, 'en-info': !$theme}" 
          :style="positions[solutionDetail.overview.overviewDesc.length][ind].style" 
          class="info" 
          v-for="(item,ind) in solutionDetail.overview.overviewDesc" 
          :key="ind+'ee'"
        >
          <div class="info-title">{{ $theme ? item.title : item.title_eng }}</div>
          <div class="info-content">{{ $theme ? item.detail : item.detail_eng }}</div>
        </div>
      </div>
    </div>
    <div class="four-con">
      <!-- <img src="../../assets/img/solution/yinying-1.png" alt=""> -->
       <div class="four-content">
      <div class="new-title">
        <div class="cn-name">{{ $theme ? "方案优势" : "SOLUTION ADVANTAGES"}}</div>
        <div class="en-name">{{ $theme ? "Solution Advantages" : '' }}</div>
        <div class="new-line"></div>
      </div>
      <div :class="`${$theme?'':'eng'}`" class="content" :style="{width: (752+116*(solutionDetail.advantages.length-1))+'px' }">
        <div
          @mouseenter="activeHonor = ind"
          :class="{ 'active-list': activeHonor == ind }"
          class="list-item"
          v-for="(item, ind) in solutionDetail.advantages"
          :key="ind + 'sd'"
          :style="{
            left: activeHonor < ind ? honorList[ind].activeLeft : honorList[ind].left,
            backgroundImage: 'url('+(activeHonor == ind ? bgImgList[ind] : bgImgList2[ind])+')'
            }"
        >
          <div class="name">
            <div class="name-text">{{ $theme ? item.title.replace(',',' ').replace('，',' ').replace('、',' ') : item.title_eng.replace(',',' ').replace('，',' ').replace('、',' ') }}</div>
          </div>
          <div class="right-img">
            <div v-if="!$theme" class="eng-title">{{ item.title_eng }}</div>
            <div class="desc-info">{{ $theme ? item.detail : item.detail_eng }}</div>
            
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="five-con" v-if="$theme">
      <img class="point-bg" :src="pointBg" alt="">
      <div class="five-content">
      <div class="new-title" style="margin-bottom: 60px;">
        <div class="cn-name">{{ $theme ? "代表案例" : "TYPICAL CASES"}}</div>
        <div class="en-name">{{ $theme ? "Typical Cases" : '' }}</div>
        <div class="new-line"></div>
      </div>
      <div class="one-case" v-for="(item, ind) in solutionDetail.cases" :key="ind + 'ss'">
        <div class="left-info">
          <div class="left-info-title">{{ $theme ? item.title : item.title_eng }}</div>
          <div class="left-info-content">{{ $theme ? item.detail : item.detail_eng }}</div>
        </div>
        <div class="right-img">
          <img :src="imageObj[solutionDetail.title].cases[item.title]" alt="">
          <div class="img-con" :style="{backgroundImage: 'url('+imageObj[solutionDetail.title].cases[item.title]+')'}"></div>
        </div>
      </div>
    </div>
    </div>
    <div class="five-con-eng" v-else>
      <img class="point-bg" :src="pointBg" alt="">
      <div class="five-content">
      <div class="new-title" style="margin-bottom: 60px;">
        <div class="cn-name">{{ $theme ? "代表案例" : "SOLUTION ADVANTAGES"}}</div>
        <div class="en-name">{{ $theme ? "Solution Advantages" : '' }}</div>
        <div class="new-line"></div>
      </div>
      <div class="one-case" v-for="(item, ind) in solutionDetail.cases" :key="ind + 'ss'">
        <div class="left-info-title">{{ $theme ? item.title : item.title_eng }}</div>
        <div class="left-info">
          <div class="left-info-content">{{ $theme ? item.detail : item.detail_eng }}</div>
          <div class="right-img">
          <img :src="imageObj[solutionDetail.title].cases[item.title]" alt="">
          <div class="img-con" :style="{backgroundImage: 'url('+imageObj[solutionDetail.title].cases[item.title]+')'}"></div>
        </div>
        </div>
        
      </div>
    </div>
    </div>
    <div class="six-con">
      <!-- <img src="../../assets/img/solution/yinying-1.png" alt=""> -->
       
      <div class="new-title new-title2">
        <div class="cn-name">{{ $theme ? "应用产品" : "APPLICATION PRODUCTS"}}</div>
        <div class="en-name">{{ $theme ? "Application Products" : '' }}</div>
        <div class="new-line"></div>
      </div>
      <div class="tab-area">
        <div class="item" @click="activeTab = 1" :class="{'active-tab': activeTab == 1}">
          {{$theme ? "软件产品" : "Software"}}
        </div>
        <div class="item" @click="activeTab = 2" :class="{'active-tab': activeTab == 2}">
          {{$theme ? "硬件产品" : "Hardware"}}
        </div>
      </div>
      <div class="ware-con">
        <template v-if="activeTab == 2">
          <div class="one-ware" v-for="(item,ind) in hardwareList" :key="ind+'h'">
            <div class="inner" @mouseleave="activeWare = ''" :class="{'active-ware': activeWare == item.code}" @mouseenter="activeWare = item.code">
              <div class="title">{{ $theme ? item.title : item.titleEng }}</div>
              <div @click="toProdectPage(2, item)" class="more" v-if="item.code == activeWare">{{ $theme ? '了解更多 >' : 'Learn More >' }}</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="one-ware" v-for="(item,ind) in softwareProductList" :key="ind+'s'">
            <div class="inner" @mouseleave="activeWare = ''" :class="{'active-ware': activeWare == item.code}" @mouseenter="activeWare = item.code">
              <div class="title">{{ $theme ? item.title : item.titleEng }}</div>
              <div @click="toProdectPage(1, item)" class="more" v-if="item.code == activeWare">{{ $theme ? '了解更多 >' : 'Learn More >' }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <ModelSix @toTop="backToTop"></ModelSix>
    <Soft
      v-if="softDetailVisible"
      :obj="obj"
      @close="
        softDetailVisible = false;
        obj = null;
      "
    ></Soft>
    <Hard
      v-if="hardDetailVisible"
      :obj="obj"
      @close="
        hardDetailVisible = false;
        obj = null;
      "
    ></Hard>
  </div>
</template>

<script>
import caseImg from '../../assets/img/solution/case-img.png'
import ModelSix from "@/views/home/components/model-six/Index.vue";
import Soft from "../product-detail/soft/Index.vue";
import Hard from "../product-detail/hard/Index.vue";
import { getSolutionDetail } from '@/api/solution.js';
import { imageObj } from './image.js';
import pointBg from '/static/image/home/point-bg.png'
export default {
  name: 'SolutionDetail',
  components: {
    ModelSix,
    Soft, Hard 
  },
  data() {
    return {
      imageObj,
      pointBg,
      activeTab: 1,
      activeWare: '',
      solutionDetail: {
        painPoints: [],
        overview: {
          overviewDesc: []
        },
        advantages: [],
      },
      indexImgList: [
        require('../../assets/img/solution/index-1.png'),
        require('../../assets/img/solution/index-2.png'),
        require('../../assets/img/solution/index-3.png'),
        require('../../assets/img/solution/index-4.png'),
      ],
      bgImgList: [
        require('../../assets/img/product/soft-bg-1.png'),
        require('../../assets/img/product/soft-bg-2.png'),
        require('../../assets/img/product/soft-bg-3.png'),
        require('../../assets/img/product/soft-bg-4.png'),
      ],
      bgImgList2: [
        require('../../assets/img/product/soft-bg-1-dark.png'),
        require('../../assets/img/product/soft-bg-2-dark.png'),
        require('../../assets/img/product/soft-bg-3-dark.png'),
        require('../../assets/img/product/soft-bg-4-dark.png'),
      ],
      positions: {
        3: [
          {
            style: {left: '-34px', top: '400px'}
          },
          {
            style: {left: '455px', bottom: '75px'}
          },
          {
            style: {right: '-30px', top: '400px'}
          },
        ],
        4: [
          {
            style: {left: '-34px', top: '400px'}
          },
          {
            style: {left: '155px', bottom: '75px'}
          },
          {
            style: {right: '205px', bottom: '75px'}
          },
          {
            style: {right: '-30px', top: '400px'}
          },
        ],
        5: [
          {
            style: {left: '-34px', top: '400px'}
          },
          {
            style: {left: '75px', bottom: '155px'}
          },
          {
            style: {left: '455px', bottom: '75px'}
          },
          {
            style: {right: '75px', bottom: '155px'}
          },
          {
            style: {right: '-30px', top: '400px'}
          },
        ]
      },
      caseImg,
      activeHonor: 0,
      honorList: [
        {
          name: "相关获奖",
          code: 1,
          img: "",
          left: "0",
          activeLeft: "0",
        },
        {
          name: "标准引领",
          code: 2,
          img: "",
          left: "116px",
          activeLeft: "752px",
        },
        {
          name: "专利证书",
          code: 3,
          img: "",
          left: "232px",
          activeLeft: "868px",
        },
        {
          name: "产学研合作",
          code: 4,
          img: "",
          left: "348px",
          activeLeft: "984px",
        },
      ],
      showAnimated: false,
      showHeader: true,
      hardwareList:[],
      softwareProductList:[],
      softDetailVisible: false,
      hardDetailVisible: false,
      obj: null,
    }
  },
  
  methods: {
    toProdectPage(type, item) {
      console.log(type, item);
      this.obj = item;
      if(type == 1) {
        this.softDetailVisible = true;
      }else {
        this.hardDetailVisible = true;
      }
    },
    init() {
      let code = this.$route.query.code
      getSolutionDetail().then(res=>{
        this.solutionDetail = JSON.parse(res.data?.find(item=>{
          return item.code == code
        }).content)
        console.log(this.solutionDetail);
        
      })
      let item = JSON.parse(sessionStorage.getItem('solutionTree')).find(ele=>ele.code == code)
      console.log(item);
      this.hardwareList = item.hardwareList
      this.softwareProductList = item.softwareProductList
    },
    backToTop() {
      document
        .getElementById("solution-top")
        .scrollTo({ left: 0, top: 0, behavior: "smooth" });
    },
  },
  created() {
    this.init()
  },
  mounted() {
    // this.$nextTick(()=>{
      
    // })
    var element = document.getElementById("solution-detail");
    console.log(132123,element);
    
    element.addEventListener("scroll", () => {
      var scrollTop = element.scrollTop;
      var scrollHeight = element.scrollHeight;
      var clientHeight = element.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight) {
        // 页面已滚动到底部
        this.$bus.$emit("change-show-header", false);
        console.log("到底部");
        // 在这里加载更多数据等操作
      } else {
        this.$bus.$emit("change-show-header", true);
      }
      if(scrollTop >=1800) {
        this.showAnimated = true;
      }
      if (scrollTop>0) {
        // 页面已滚动到底部
        this.$bus.$emit("change-show-header", false);
      } else {
        this.$bus.$emit("change-show-header", true);
      }
    });
  }
}
</script>
<style lang="scss" scoped>
@import './Index.scss';
</style>
